export const formatProductLink = (skuId: string, skuName?: string, inner: boolean = true, limit = 6) => {
  // skuName 过滤非英文、数字及空格
  (skuName = skuName?.replace(/[^a-zA-Z0-9\s]/g, '')?.split(" ")?.slice(0, limit)?.join('-'))
  return skuName ? `/dp/${skuName}/${skuId}` : `/dp/${skuId}`
}
